import { PropsWithChildren, JSX } from 'react';

interface IProps {
    components: ((props: PropsWithChildren) => JSX.Element)[];
}

export const ComposeComponents = (props: PropsWithChildren<IProps>): JSX.Element => (
    <>
        {props.components.reduceRight(
            (Acc, Comp) => (
                <Comp>{Acc}</Comp>
            ),
            props.children,
        )}
    </>
);
